import { render, staticRenderFns } from "./ChangeSeatingPlanKL.vue?vue&type=template&id=2575cf7a&"
import script from "./ChangeSeatingPlanKL.vue?vue&type=script&lang=js&"
export * from "./ChangeSeatingPlanKL.vue?vue&type=script&lang=js&"
import style0 from "./ChangeSeatingPlanKL.vue?vue&type=style&index=0&id=2575cf7a&prod&.scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAvatar,VCard,VCardTitle,VCol,VContainer,VImg,VRow,VSpacer,VToolbar})
